export const HEADER = "تم التحويل";
export const COMPLETED_TRANSFERS_TAB = "تم التحويل";
export const BUTTON = {
  SEARCH: "اسم المستخدم",
};
export const TABLE_HEADERS = {
  TRANSACTION_ID: "الرقم المرجعي",
  USERNAME: "المستخدم",
  TRANSFER_TIME: "وقت التحويل",
  AMOUNT: "القيمة",
  TRANSFER_CHANNEL: "تمت عبر",
  TRANSFER_TYPE: "النوع",
};
